export default __webpack_public_path__ + "static/media/carousel_image.7b2811fd.png";